import { UserSortKey } from '../types';
import { getSortIcon } from './sort-icon';

export { getSortIcon as getUserSortIcon };

export function getUserAriaSort(
  column: UserSortKey,
  currentColumn: UserSortKey,
  direction: 'asc' | 'desc'
): 'ascending' | 'descending' | 'none' {
  return currentColumn === column
    ? direction === 'asc' ? 'ascending' : 'descending'
    : 'none';
}
